export default class Xtc {
  constructor(key, title) {
    this.key = key;
    this.title = title;
    this.dataIndex = key;
    this.show = true;
    this.__sorter = true;
  }

  export() {
    let exp = {};
    exp['key'] = this.key;
    exp['__key'] = this.__fkey;
    exp['dataIndex'] = this.key;
    exp['title'] = this.title;
    if (this._slots) {
      if(!this._slots.filterIcon){
        this._slots.filterIcon = 'filterIcon';
      }
      exp['scopedSlots'] = this._slots;
    }
    if (this.filter) {
      this.filter = this.filterType;
      this.filtered = true;
    }
    return exp;
  }

  filterKey(key){
    this.__fkey = key;
    this.master = key;
    return this;
  }

  renderSlot(name) {
    this._slots = {
      customRender: name
    };
    if (!this.scopedSlots) {
      this.scopedSlots = {}
    }
    this.scopedSlots.customRender = name;
    return this;
  }

  __filter() {
    this.filtered = true;
    if (!this._slots) {
      this.scopedSlots = {};
    }
    this.scopedSlots.filterDropdown = `${this.key}_filterDropdown`;
    this.scopedSlots.filterIcon = `${this.key}_filterIcon`;
  }

  filterText() {
    this.__filter();
    this.filterType = 'default';
    return this;
  }

  filterSwitch() {
    this.__filter();

    this.filterType = 'switch';
    return this;
  }


  filterQuery(action) {
    this.__filter();
    this.filterType = 'query';
    this.filterAction = action;
    return this;
  }

  filterDate() {
    this.__filter();
    this.filterType = 'date';
    return this;
  }

  filterSelect(items) {
    this.__filter();
    this.filterType = 'select';
    this.filterItems = items;
    return this;
  }

  filterNumber() {
    this.__filter();
    this.filterType = 'number';
    return this;
  }

  noSort() {
    this.__sorter = false;
    return this;
  }

  hidden() {
    this.show = false;
    return this;
  }

}

